<template xmlns='http://www.w3.org/1999/html'>
  <Toast />
  <button
    style="margin-bottom: 15px"
    class="inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm"
    @click="redirectToLastPage()"
  >
    <svg
      class="w-5 h-5 mr-2"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 19l-7-7 7-7"
      />
    </svg>
    Retour
  </button>
  <div class=" overflow-hidden">

  <div class="row-auto flex justify-between items-center mb-4">
    <span class="title">{{ title }}</span>
  </div>
  <Dialog header="Ajouter une nouvelle valeur" v-model:visible="showDialog" :modal="true" :closable="false">
    <div class="p-fluid">
      <div class="p-field">
        <label for="new-value">Nouvelle Valeur</label>
        <FormKit
            type="text"
            id="new-value"
            v-model="newValue"
            validation="length:0,100"
            :validation-messages="{
              length: 'Le nom de la propriété ne peut pas dépasser 100 caractères' 
              }"            
        />
          <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      </div>
      <div class="p-field flex justify-between mt-4">
        <Button label="Ajouter" icon="pi pi-check" class="p-button-success mr-3" @click="addNewValue" />
        <Button label="Annuler" icon="pi pi-times" class="p-button-warning" @click="cancelNewValue" />
      </div>
    </div>
  </Dialog>
    <DataTable
      :value="tableData"
      :rows="rows"
      :paginator="true"
      :loading="isLoading"
      :rowsPerPageOptions="rowsPerPageOptions"
      lazy
      @page="onPaginate"
      :currentPage="currentPage"
      :totalRecords="totalRecords"
      editMode="row"
      dataKey="uuid"
      v-model:editingRows="editingRows"
      @row-edit-save="onRowEditSave"
      class="p-datatable-custom"
    >
      <template #header>
        <div class="header-container">
          <div class="search-container search-container-right">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="criteria"
              @keyup.enter="onFilterDt"
              @input="onClearInputFilter"
              placeholder="Rechercher une valeur"
              class="w-full search-right"
            />
          </span>
            <Button icon="pi pi-plus" class="btn-round-blue ml-4 mr-5" @click="openNew" />
          </div>
        </div>
      </template>
      <Column headerStyle="background-color: #F4F5F7; color: #111827; text-align: center;" field="value" header="Valeur de la propriété" style="width: 80%">
        <template #editor="{ data, field }">
            <FormKit
                type="text"
                :id="field"
                :name="field"
                v-model="data[field]"
                @input="value => data[field] = value"
                validation="length:0,255"
                :validation-messages="{
              length: 'Le nom de la valeur de propriété ne peut pas dépasser 255 caractères',
            }"            />
        </template>
      </Column>
        <Column headerStyle="background-color: #F4F5F7; color: #111827; text-align: center;" :rowEditor="true" style="width: 3%; position: relative; " bodyStyle="text-align:right padding-right: 0.5em; right: -3rem;"></Column>
        <template #empty>Aucun résultat trouvé.</template>
      <Column headerStyle="background-color: #F4F5F7; color: #111827; text-align: center;" bodyStyle="text-align: center;">
        <template #header>
          <div style="width: 100%; text-align: center;">Actions</div>
        </template>
        <template #body="slotProps" >
          <Button
            size="small"
            icon="pi pi-pencil"
            class="custom-button p-button-warning"
            :class="`${slotProps.data.uuid}`"
            style="margin-right: 0.5em"
            title="Éditer les produits associés"
            @click="addVariantProductToPropertyValue(slotProps.data.uuid)"
          />
          <Button
            size="small"
            icon="pi pi-eye"
            class="custom-button  p-button-eye"
            :class="`${slotProps.data.uuid}`"
            style="margin-right: 0.5em"
            title="voir les produits associés"
            @click="listVariantProductsOfPropertyValue(slotProps.data.uuid)"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script lang="ts" setup>
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import usePropertyService from '@/_services/propertyValue/propertyValue';
import { onMounted } from 'vue';

const openNew = () => {
  showDialog.value = true;
};
const validateInput = (data, field) => {
  if (data[field].length > 255) {
    if (!data.errors) {
      data.errors = {};
    }
    data.errors[field] = 'La valeur ne peut pas dépasser 255 caractères.';
  } else {
    if (data.errors) {
      delete data.errors[field];
    }
  }
};
const {
  page,
  defaultRowsPerPage,
  rowsPerPageOptions,
  rows,
  isLoading,
  tableData,
  currentPage,
  criteria,
  totalRecords,
  title,
  editingRows,
  showDialog,
  newValue,
  initProperty,
  populateDatatable,
  addVariantProductToPropertyValue,
  listVariantProductsOfPropertyValue,
  onPaginate,
  onFilterDt,
  onClearInputFilter,
  redirectToLastPage,
  onRowEditSave,
  addNewValue,
  errorMessage,
  cancelNewValue
} = usePropertyService();

onMounted(initProperty);
</script>

<style scoped lang="scss">
@import "primevue/resources/themes/tailwind-light/theme.css";
@import "primevue/resources/primevue.min.css";
@import "primeicons/primeicons.css";

select {
  @apply font-normal;
}
.card-body {
  @apply bg-white;
}
.search-container {
  display: flex;
  justify-content: space-between;
}

.custom-button:hover {
  border-color: #5E81AC;
  background: #ffffff;
}

.btn-round-blue {
  background-color: #111827 !important;
  color: white !important;
  border: 1px solid #d0d0d0 !important;
  border-radius: 50% !important;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
}

.btn-round-blue:hover {
  background-color: white !important;
  color: #111827 !important;
}
.search-container-right {
  display: flex;
  justify-content: flex-end;
}
.title{
  color: #09224F !important;
  flex-grow: 1;
  font-size: 20px;
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
  &:after {
    content: "";
    background: #F4F5F7;
    width: 35px;
    height: 3px;
    position: absolute;
    bottom: -5px;
    left: 0;
    display: block;
  }
}
.header-container {
  display: flex;
  justify-content: flex-end;
  align-items: center; 
}
.search-right {
  background-color: #F4F5F7 !important;
  border: none !important;
  &:hover{
    border: none !important;
    background-color: white !important;
  }
}
.p-inputtext {
  width: 100% !important;
}
.error-message {
  color: red;
  margin-top: 0.5em;
}
</style>
